export const appName = "ATP";
export const appFullName = "AutoTrade Port";
export const appLogo_url = "";
export const appContact_number = "+923030303030";
export const colors = {
  primary: "#2563eb",
  primaryDark: "#1d4ed8",
  primaryLight: "#3b82f6",
  secondary: "#0f172a",
  secondary2: "#64748b",
  info: "#f8fafc",
  info_5: "rgb(204, 204, 204, 0.5)",
  infoPlus: "#f1f5f9",
  primaryInfo: "#dbeafe",
  success: "#06b6d4",
  error: "#dc2626",
  warning: "#d97706",
  black: "#000",
  white: "#fff",
};
